<template>
  <!-- 数据统计时间筛选组件 -->
  <div>
    <Tabs class="tabs" title="商户管理" />
    <div class="box">
      <blue-title class="style">超级管理员信息</blue-title>
      <SuperAdminInfo :count.sync="count" :allData="allData" @confirm="handleValiditySuperAdminInfo"></SuperAdminInfo>
      <div class="btn">
        <el-button type="info" @click="back">返回</el-button>
        <el-button type="info">保存草稿</el-button>
        <el-button type="primary" @click="count++">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SuperAdminInfo from '../../components/superAdminInfo/superAdminInfo';
import { saveEditDraft, draftEcho } from '../../../../api/module/merchants';

export default {
  components: {
    SuperAdminInfo,
  },
  props: {},
  data() {
    return {
      SuperAdminInfo: {
        identity: '0',
        contactName: '',
        contactIdNumber: '',
        openid: '',
        mobilePhone: '',
        contactEmail: '',
      },
      count: 0, // 是否开始验证
      SuperAdminPass: false,
      allData: {},
    };
  },
  computed: {
    id() {
      return this.$route.query.id;
    },
    type() {
      return this.$route.query.type;
    },
    subjectName() {
      return this.$route.query.subjectName;
    },
    facilitatorName() {
      return this.$route.query.facilitatorName;
    },
    uuid() {
      return this.$route.query.uuid;
    },
    merchantId() {
      return this.$route.query.merchantId;
    },
  },
  watch: {},
  created() {
    if (this.type == 'edit') {
      this.draftEcho();
    }
  },
  methods: {
    handleValiditySuperAdminInfo({ flag, ruleForm }) {
      this.SuperAdminInfo = { ...ruleForm };
      this.SuperAdminPass = flag;
      this.handleSave();
    },
    handleSave() {
      const { SuperAdminPass } = this;
      if (SuperAdminPass) {
        console.log('成功');
        const obj = this.formatSubmitData();
        console.log('处理后的数据===', obj);
        this.saveEditDraft(obj);
      } else {
        console.log('失败');
      }
    },
    formatSubmitData() {
      let obj = {};
      // const { id } = this.$route.query;
      const { SuperAdminInfo, uuid, merchantId } = this;
      obj = {
        superAdministratorInformationVO: {
          identity: SuperAdminInfo.identity,
          contactEmail: SuperAdminInfo.contactEmail,
          contactIdNumber: SuperAdminInfo.contactIdNumber,
          contactName: SuperAdminInfo.contactName,
          mobilePhone: SuperAdminInfo.mobilePhone,
          openid: SuperAdminInfo.openid,
          uuid: '',
        },
        uuid,
        merchantId,
        type: 'superAdministrator',
        listVO: {
          status: 0,
          subjectType: this.subjectName,
          merchantType: this.facilitatorName,
        },
      };
      return obj;
    },
    async saveEditDraft(obj) {
      console.log(obj);
      // const result = await saveEditDraft({ ...obj });
      try {
        const result = await saveEditDraft({ ...obj });
        console.log('保存结果', result);
        this.$message({
          message: '保存成功',
          type: 'success',
          duration: 1500,
          onClose: () => {
            this.$router.replace({
              path: '/merchants/addMerchants',
              query: {
                id: this.id,
                subjectName: this.subjectName,
                facilitatorName: this.facilitatorName,
                type: 'edit',
                uuid: result,
                merchantId: this.merchantId
              },
            });
          },
        });
      } catch (err) {
        this.$message({
          message: '保存失败',
          type: 'warring',
          duration: 1500,
        });
      }
    },
    back() {
      this.$router.replace({
        path: '/merchants/addMerchants',
        query: {
          id: this.id,
          subjectName: this.subjectName,
          facilitatorName: this.facilitatorName,
          type: this.type,
          merchantId: this.merchantId,
          uuid: this.uuid,
        },
      });
    },
    async draftEcho() {
      const result = await draftEcho({
        uuid: this.uuid,
      });
      this.allData = result;
      console.log('回显所填信息', result);
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  background-color: white;
  padding-top: 20px;
  .style {
    margin-bottom: 9px;
  }
  .btn {
    box-sizing: border-box;
    padding-left: 31px;
    margin-top: 57px;
    padding-bottom: 10px;
  }
}
</style>
